
import { NoseurObject } from "@rivtn/noseur";
import { LanuariusBaseService } from "./LanuariusBaseService";

export class AuthService extends LanuariusBaseService {

    protected static instance: AuthService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!AuthService.instance) AuthService.instance = new AuthService();
        return AuthService.instance;
    }

    signup(payload: NoseurObject<any>): Promise<any>  {
        return this.report(this.transport.post("/janus/lanuarius/api/v1/user", payload));
    }

    signin(payload: NoseurObject<any>): Promise<any>  {
        return this.report(this.transport.post("/janus/lanuarius/api/v1/user/auth", payload));
    }

    refreshToken(accessToken: string, payload: NoseurObject<any>): Promise<any>  {
        return this.report(this.transport.post("/janus/lanuarius/api/v1/user/auth/refresh", payload, this.buildAuthRequestConfig(accessToken)));
    }

    requestSignInFaCodes(accessToken: string, payload: NoseurObject<any>): Promise<any>  {
        return this.report(this.transport.post("/janus/lanuarius/api/v1/user/auth/2fa/code", payload, this.buildAuthRequestConfig(accessToken)));
    }

    confirmSignInFa(accessToken: string, payload: NoseurObject<any>): Promise<any>  {
        return this.report(this.transport.post("/janus/lanuarius/api/v1/user/auth/2fa", payload, this.buildAuthRequestConfig(accessToken)));
    }

    sendActorAuthenticatorCodes(accessToken: string, sessionToken: string): Promise<any>  {
        return this.report(this.transport.post("/janus/lanuarius/api/v1/account/actor/authenticator/reset/request", { session_token: sessionToken }, this.buildAuthRequestConfig(accessToken)));
    }

    sendActorAuthenticatorEmail(accessToken: string, payload: NoseurObject<any>): Promise<any>  {
        return this.report(this.transport.post("/janus/lanuarius/api/v1/account/actor/authenticator/reset/email", payload, this.buildAuthRequestConfig(accessToken)));
    }

    sendPasswordResetEmail(payload: NoseurObject<any>): Promise<any>  {
        return this.report(this.transport.post("/janus/lanuarius/api/v1/account/password/reset/email", payload));
    }

    resetPassword(accessToken: string, payload: NoseurObject<any>): Promise<any>  {
        return this.report(this.transport.post("/janus/lanuarius/api/v1/account/password/reset", payload, this.buildAuthRequestConfig(accessToken)));
    }

    getProfile(accessToken: string): Promise<any>  {
        return this.report(this.transport.get("/janus/lanuarius/api/v1/account", this.buildAuthRequestConfig(accessToken)));
    }

    requestEmailVerification(accessToken: string, userId: string, prefix: string): Promise<any>  {
        return this.report(this.transport.get(`/janus/lanuarius/api/v1/account/verify/${userId}`, {
            params: {
                prefix,
            },
            ...this.buildAuthRequestConfig(accessToken)
        } as any));
    }

    verifyEmail(accessToken: string, payload: NoseurObject<any>): Promise<any>  {
        return this.report(this.transport.post("/janus/lanuarius/api/v1/account/verify", payload, this.buildAuthRequestConfig(accessToken)));
    }

}
